
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Website, WebsiteComposite, WebsiteDetails } from '@/services/Website/interfaces';
import StatusChip from '@/components/layout/StatusChip.vue';

@Component({
  components: { StatusChip },
})
export default class WebsiteDetailResult extends Vue {
  @Prop({ type: Object, required: true })
  public composite!: WebsiteComposite;

  public get website(): Website {
    return this.composite.website;
  }

  public get details(): WebsiteDetails {
    return this.composite.details || this.website.details;
  }
}
